/* rpf-miniaturas-volta.js — 01/10/2026, pedido do Jonatas.
 * No computador, clicar na ÚLTIMA miniatura visível já rola a fileira para a frente (media-gallery.js do
 * tema: isSlideVisible → scrollTo). O inverso não existia: clicar na PRIMEIRA visível, com miniaturas
 * escondidas à esquerda, não fazia nada. Aqui: nesse caso a fileira volta até a clicada ficar no meio,
 * mostrando as anteriores. Não mexe no avanço do tema nem no celular. */
(function () {
  if (!window.matchMedia('(min-width: 750px)').matches) return;
  function liga(galeria) {
    var lista = galeria.querySelector('[id^="GalleryThumbnails"] .thumbnail-list');
    if (!lista || lista.dataset.rpfVolta) return;
    lista.dataset.rpfVolta = '1';
    lista.addEventListener('click', function (e) {
      var item = e.target.closest('.thumbnail-list__item');
      if (!item || !lista.contains(item)) return;
      // posição da miniatura dentro da parte visível da fileira, medida ANTES de o tema rolar
      var esq = item.getBoundingClientRect().left - lista.getBoundingClientRect().left;
      var largura = item.getBoundingClientRect().width;
      var temEscondidaAntes = lista.scrollLeft > 2;
      if (!temEscondidaAntes || esq > largura * 0.6) return; // não é a primeira visível
      setTimeout(function () {
        var alvo = item.offsetLeft - (lista.clientWidth - item.offsetWidth) / 2;
        lista.scrollTo({ left: Math.max(0, alvo), behavior: 'smooth' });
      }, 60); // depois do scrollTo do próprio tema
    });
  }
  function tudo() { document.querySelectorAll('media-gallery').forEach(liga); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo); else tudo();
})();
